export function distanceMeters([lat1, lng1], [lat2, lng2]) {
  const R = 6371000;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function formatDistance(m) {
  return m < 1000 ? `${Math.round(m / 10) * 10} m` : `${(m / 1000).toFixed(1)} km`;
}

// Groups spots whose pins are closer than `px` pixels at the current zoom.
export function clusterSpots(spots, map, px = 48) {
  const groups = [];
  spots.forEach((s) => {
    const p = map.latLngToLayerPoint([s.lat, s.lng]);
    const g = groups.find((x) => x.point.distanceTo(p) < px);
    if (g) g.spots.push(s);
    else groups.push({ point: p, spots: [s] });
  });
  return groups.map((g) => ({
    spots: g.spots,
    lat: g.spots.reduce((a, s) => a + s.lat, 0) / g.spots.length,
    lng: g.spots.reduce((a, s) => a + s.lng, 0) / g.spots.length,
  }));
}

// Parses the theatre show date + time like "21.00" or "14-20" into a Date (Europe/Rome local).
export function showStart(show) {
  const m = (show?.time || "").match(/(\d{1,2})(?:[.:](\d{2}))?/);
  if (!show?.date || !m) return null;
  return new Date(`${show.date}T${m[1].padStart(2, "0")}:${m[2] || "00"}:00`);
}
